import cn from 'classnames';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import mask_group from '../../../../../assets/image/mask_group.png';
import defaultImg from '../../../../../assets/image/newShop/defaultImg.png';
import pattern from '../../../../../assets/image/pattern.png';
import DotsLoading from '../../../../../components/dotsLoading';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import {useGetSupplierStories} from '../../../../../components/mazraeKit/story/hooks';
import {useAuth} from '../../../../../context/authContext';
import StorySection from '../../../../../module/newShop/home/StorySection';
import useGetCooperationAgreementStatus from '../../../../../services/hookService/getCooperationAgreementStatus/useGetCooperationAgreementStatus';
import useGetDetailShopCard from '../../../../../services/hookService/getDetailShopCard/useGetDetailShopCard';
import useGetStoreCommentsAndRateCounts from '../../../../../services/hookService/getStoreCommentsAndRateCounts/useGetStoreCommentsAndRateCounts';
import {usePatchActivateStore} from '../../../../../services/hookService/patchActivateStore/usePatchActivateStore';
import {googleAnalyticsInstance} from '../../../../../utilities/helper/googleAnalitics';
import useGetProfile from '../../../../profile/hooks/useGetProfile';
import {handleMenulList} from '../../contants';
import ActivateEditedBottomSheet from '../../elements/bottomSheetLists/activateEditedBottomSheet';
import CommentsAndRateBottomSheet from '../../elements/bottomSheetLists/commentsAndRateBottomSheet';
import ChartTabBar from '../../elements/chartTabBar';
import SignStatusBadge, {
  ContractStatusEnum,
} from '../myStoreSalesPartnershipAgreement/components/SignStatusBadge';
import PendingRenewalBottomSheet from '../myStoreSalesPartnershipAgreement/myStorePartnershipAgreementLicense/PendingRenewalBottomSheet';
import SuccessTerminationRequestSendBottomSheet from '../myStoreSalesPartnershipAgreement/myStorePartnershipAgreementLicense/SuccessTerminationRequestSendBottomSheet';

const MyStoreInfo = () => {
  const navigate = useNavigate();

  const {supplierProfile} = useAuth();
  const {stories: storesWithStory} = useGetSupplierStories();
  const [isShowStories, setIsShowStories] = useState(false);
  const {profile, isLoading} = useGetProfile(supplierProfile?.guid || '', true);
  const logo = supplierProfile?.store?.logo || supplierProfile?.lab?.logo;
  const {data: rateAndCommentsData} = useGetStoreCommentsAndRateCounts();
  const [openCommentRateBottomSheet, setOpenCommentRateBottomSheet] =
    useState(false);

  const [openActivateEditedBottomSheet, setOpenActivateEditedBottomSheet] =
    useState(false);

  const [activateStore, setActivateStore] = useState(true);
  const [openPendingTerminationSheet, setOpenPendingTerminationSheet] =
    useState(false);
  const [openPendingRenewalSheet, setOpenPendingRenewalSheet] = useState(false);
  const {mutate} = usePatchActivateStore({});

  useEffect(() => {
    if (isLoading) return;

    if (!profile?.supplier_profile?.store && !profile?.supplier_profile?.lab) {
      navigate('/my-store');
    }
    if (
      (profile?.supplier_profile?.store &&
        profile?.supplier_profile?.store?.store_status !== 'accepted') ||
      (profile?.supplier_profile?.lab &&
        profile?.supplier_profile?.lab?.lab_status !== 'accepted')
    ) {
      navigate('/my-store');
    } else if (
      !profile?.supplier_profile?.store?.is_active &&
      !profile?.supplier_profile?.lab?.is_active
    ) {
      setActivateStore(false);
      setOpenActivateEditedBottomSheet(true);
    }
  }, [profile, isLoading]);

  const storeGuid = supplierProfile?.store?.guid;
  const {cardDetailData} = useGetDetailShopCard({guid: storeGuid!});
  const isSaleAgent = cardDetailData?.is_sale_agent;

  const {contractStatus} = useGetCooperationAgreementStatus();

  const handleRouteChange = (route: string) => {
    if (route === '/my-store-sales-partnership-agreement') {
      switch (contractStatus) {
        case ContractStatusEnum.Empty:
          navigate(
            '/my-store-sales-partnership-agreement/hasLicenseAgreement=' +
              false,
          );
          break;

        case ContractStatusEnum.NotCompleted:
          window.location.replace('https://app.emzano.com');
          break;

        case ContractStatusEnum.RenewalRequest:
          setOpenPendingRenewalSheet(true);
          break;

        case ContractStatusEnum.TerminationRequested:
          setOpenPendingTerminationSheet(true);
          break;

        case ContractStatusEnum.Archived:
          navigate(
            '/my-store-sales-partnership-agreement/hasLicenseAgreement=' +
              false,
          );
          break;

        case ContractStatusEnum.ExpiringSoon:
          navigate(
            '/my-store-sales-partnership-agreement/hasLicenseAgreement=' + true,
          );
          break;

        case ContractStatusEnum.Signed:
          // Navigate to signed agreement details
          navigate(
            '/my-store-sales-partnership-agreement/hasLicenseAgreement=true',
          );
          break;
      }
    } else {
      // For other routes, navigate normally
      navigate(route);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-dvh">
          <div dir="ltr">
            <DotsLoading />
          </div>
        </div>
      ) : (
        <div
          className="relative flex flex-col w-full h-full"
          onClick={() => {
            !activateStore && setOpenActivateEditedBottomSheet(true);
          }}
        >
          <CustomHeader
            title={
              supplierProfile?.store?.guid
                ? 'فروشگاه من'
                : supplierProfile?.lab?.guid
                ? 'آزمایشگاه من'
                : ''
            }
            preIcon="icon-nameArrow---Right"
            isActiveRightIcon={true}
            backRoute="/home"
            postComponent={() => (
              <div className="flex gap-3 ">
                <NotificationHeaderIcon />
                <ChatHeaderIcon />
              </div>
            )}
          />

          <div className="h-full p-3 overflow-y-auto">
            <section
              className={cn('relative rounded shadow-md', {
                'opacity-30': !activateStore,
                'opacity-100': activateStore,
              })}
            >
              <div
                className="h-[88px] relative"
                onClick={() =>
                  storesWithStory &&
                  storesWithStory.length &&
                  storesWithStory.some(
                    story =>
                      story?.store?.guid === supplierProfile?.store?.guid,
                  )
                    ? setIsShowStories(true)
                    : activateStore && setOpenActivateEditedBottomSheet(true)
                }
              >
                <img className="w-full h-full" src={pattern} alt="pattern" />
                <div className="absolute p-1 overflow-hidden rounded-full top-full -translate-y-2/4 left-3 ">
                  <img
                    src={logo ? logo : defaultImg}
                    alt="logo"
                    className="relative z-10 object-cover w-16 h-16 rounded-full"
                  />
                  {/* ring or story */}
                  {storesWithStory &&
                  supplierProfile &&
                  storesWithStory.length &&
                  storesWithStory?.some(
                    story => story.store?.guid === supplierProfile?.store?.guid,
                  ) ? (
                    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-tl from-[#00FFF0] to-[#DBFF00] rounded-full">
                      <span className="absolute inset-0.5 bg-white rounded-full"></span>
                    </div>
                  ) : null}
                </div>
              </div>
              {isShowStories && (
                <StorySection
                  isMain={false}
                  endHandler={() => setIsShowStories(false)}
                />
              )}
              <div
                className="flex flex-col px-2 py-2"
                onClick={() =>
                  activateStore && setOpenActivateEditedBottomSheet(true)
                }
              >
                <div className="flex flex-col px-3">
                  <span className="mt-2 font-bold text-md">
                    {supplierProfile?.lab?.title ||
                      supplierProfile?.store?.title}
                  </span>
                  <span className="py-3 text-gray-700">
                    {supplierProfile?.phone_number}
                  </span>
                  {supplierProfile?.store ? (
                    <span className="mb-2 text-sm">
                      {' '}
                      {supplierProfile?.store?.state?.name} ,{' '}
                      {supplierProfile?.store?.city?.name}{' '}
                      {supplierProfile?.store?.address
                        ? `, ${supplierProfile?.store.address}`
                        : null}
                    </span>
                  ) : (
                    <span className="mb-2 text-sm">
                      {' '}
                      {supplierProfile?.lab?.state?.name} ,{' '}
                      {supplierProfile?.lab?.city?.name}
                    </span>
                  )}
                </div>
                <div className="flex items-center justify-between w-full p-2 rounded-full text-farm-shop-500 bg-farm-shop-50">
                  <span className="text-sm">نوع حساب کاربری:</span>
                  <div className="px-2 bg-white rounded-full">
                    <span className="text-xs">
                      {supplierProfile?.user_plan_info?.store_plan?.title}
                    </span>
                  </div>
                </div>
              </div>
            </section>
            {activateStore && (
              <>
                <section className="flex gap-3 mt-4">
                  <div className="flex items-center flex-1 gap-2 px-2 py-3 rounded shadow-md">
                    <div className="flex items-center justify-center w-10 h-10 p-2 rounded-full bg-farm-shop-50">
                      <i className="font-bold icon-namerate text-farm-shop-500 text-xxl" />
                    </div>
                    <div
                      className="flex flex-col font-Medium text-md"
                      onClick={() => setOpenCommentRateBottomSheet(true)}
                    >
                      <span>
                        {supplierProfile?.lab?.guid
                          ? 'امتیاز آزمایشگاه'
                          : 'امتیاز فروشگاه'}
                      </span>
                      <span>{rateAndCommentsData?.rate}</span>
                    </div>
                  </div>
                  <div
                    className="flex items-center flex-1 gap-2 px-2 py-3 rounded shadow-md"
                    onClick={() =>
                      navigate(
                        `/my-store-comments/${
                          supplierProfile?.store?.guid ||
                          supplierProfile?.lab?.guid
                        }`,
                      )
                    }
                  >
                    <div className="flex items-center justify-center w-10 h-10 p-2 rounded-full bg-farm-shop-50">
                      <i className="font-bold icon-icon---25 text-farm-shop-500 text-xxl" />
                    </div>
                    <div className="flex flex-col font-Medium text-md">
                      <span>دیدگاه مشتریان</span>
                      <span>{rateAndCommentsData?.comments_count} نظر</span>
                    </div>
                  </div>
                </section>
                <section>
                  <ChartTabBar />
                </section>
                <div
                  className="flex justify-between items-center h-32 w-full bg-gradient-to-l rounded from-[#E8DAFF] to-[#D2B7FF] p-3 mt-4 mb-16"
                  onClick={() => {
                    navigate(
                      `/set-story/${
                        supplierProfile?.store?.guid ||
                        supplierProfile?.lab?.guid
                      }`,
                    );
                    googleAnalyticsInstance.eventGoogleAnalytics({
                      category: 'setStory',
                      action: 'رو ثبت استوری کلیک شد',
                    });
                  }}
                >
                  <div className="flex flex-col text-xl">
                    <span className="font-bold text-purple-100">
                      با ثبت استوری،
                    </span>
                    <span className="font-bold text-blue-100">
                      بازدید از فروشگاهت
                    </span>
                    <span className="font-bold text-blue-100">
                      <strong className="text-4xl font-bold">100</strong>برابر
                      میشه!!
                    </span>
                  </div>
                  <div className="flex items-center justify-center">
                    <img src={mask_group} alt="" />
                    <i className="icon-styleoutline410" />
                  </div>
                </div>
                <div className="flex flex-col gap-8 pb-2">
                  {handleMenulList(
                    (supplierProfile?.store?.guid as string) ||
                      (supplierProfile?.lab?.guid as string),
                  )[supplierProfile?.store?.guid ? 'store' : 'lab'].map(
                    (item, index) => (
                      <React.Fragment key={item.id}>
                        <div
                          className={`flex justify-between  ${
                            (item.route === '/my-store-brands' ||
                              item.route === '/my-store-sale-agents') &&
                            !isSaleAgent
                              ? 'pointer-events-none opacity-40'
                              : ''
                          }`}
                          onClick={() => {
                            handleRouteChange(item.route);
                            if (item.route === '/account/promotion/store') {
                              googleAnalyticsInstance.eventGoogleAnalytics({
                                category: 'upgradeStore',
                                action: 'روارتقا فروشگاه کلیک شد',
                              });
                            } else if (item.route === '/my-store-sale-agents') {
                              googleAnalyticsInstance.eventGoogleAnalytics({
                                category: 'saleAgents',
                                action: 'رو عاملین فروش کلیک شد',
                              });
                            }
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <i
                              className={cn(
                                item.icon,
                                `${
                                  item.route === '/account/promotion/store'
                                    ? 'text-xl ml-0.5'
                                    : 'text-xxl'
                                } text-gray-700`,
                              )}
                            />
                            <span className="text-md">{item.title}</span>
                            {contractStatus &&
                              item.route ===
                                '/my-store-sales-partnership-agreement' && (
                                <SignStatusBadge status={contractStatus} />
                              )}
                          </div>
                          <i className="icon-styleoutline410" />
                        </div>
                      </React.Fragment>
                    ),
                  )}
                </div>
              </>
            )}
          </div>

          <CommentsAndRateBottomSheet
            {...{openCommentRateBottomSheet, setOpenCommentRateBottomSheet}}
          />

          <SuccessTerminationRequestSendBottomSheet
            open={openPendingTerminationSheet}
            setOpen={setOpenPendingTerminationSheet}
          />

          <PendingRenewalBottomSheet
            open={openPendingRenewalSheet}
            setOpen={setOpenPendingRenewalSheet}
          />

          <ActivateEditedBottomSheet
            {...{
              openActivateEditedBottomSheet,
              setOpenActivateEditedBottomSheet,
            }}
            data={supplierProfile}
            onToggle={() => {
              setActivateStore(!activateStore);
              setOpenActivateEditedBottomSheet(false);
              mutate({store_or_lab_status: !activateStore});
            }}
            isToggle={activateStore}
          />
          <MainFooter />
        </div>
      )}
    </>
  );
};

export default MyStoreInfo;
